const hasAccess = (user, permission) => {
  if (!user || !user.permissions) return false
  if (user.permissions.includes('*')) return true
  if (Array.isArray(permission)) {
    return permission.some(p => user.permissions.includes(p))
  }
  return user.permissions.includes(permission)
}

export default hasAccess
